export function arraysMatch(arr1, arr2){
    let match = true;
    if(arr1.length === arr2.length){
        for(let i = 0; i < arr1.length; i++){
            if(arr1[i] !== arr2[i]){
                match = false;
                break;
            }
        }
    }
    else{
        match = false;
    }
    return match;
}